import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Logo from '../assets/logo.svg';
import { BsWhatsapp } from "react-icons/bs";


const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Función para scroll suave a las secciones
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    setIsMenuOpen(false); // Cerrar menú móvil después de hacer clic
  };

  return (
    <header className="navbar-container"
      style={{
        position: 'fixed',
        display: 'flex',
        zIndex: '1000',
        width: '100%',
      }}
    >
      {/* Nav con position relative para que el menú móvil se posicione debajo */}
      <nav
        style={{
          position: 'relative',
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between', // Distribuye las tres secciones
          alignItems: 'center',
        }}
      >
        {/* Logo a la izquierda */}
        <div className='p-2'>
          <a
            href="https://bscolombia.com.co/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-80 transition-opacity duration-300"
          >
            <img src={Logo} alt="logo" className="h-10 object-contain" />
          </a>
        </div>

        {/* Menú Desktop (horizontal) */}
        <div
          className="hidden md:flex flex-1 justify-center"
          style={{ /* Mantén tus estilos en línea si deseas */ }}
        >
          <ul
            className="flex flex-row space-x-auto md:space-x-8 font-sans"
            style={{ fontSize: '0.9vw' }}
          >
            <li>
              <button
                onClick={() => scrollToSection('inicio')}
                className="hover:text-primary transition-colors duration-300"
              >
                {t('navbar.menu.kit')}
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('como-funciona')}
                className="hover:text-primary transition-colors duration-300"
              >
                {t('navbar.menu.how_it_works')}
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('features')}
                className="hover:text-primary transition-colors duration-300"
              >
                {t('navbar.menu.advantages')}
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('experts')}
                className="hover:text-primary transition-colors duration-300"
              >
                {t('navbar.menu.experts')}
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('contacto')}
                className="hover:text-primary transition-colors duration-300"
              >
                {t('navbar.menu.contact')}
              </button>
            </li>

          </ul>
        </div>

        {/* Botón a la derecha (visible sólo en desktop) */}
        <div className="flex items-center space-x-4">
          <button
            className="flex font-archivo btn-primary md:inline-flex items-center gap-2 px-4 py-2"
            type="button"
            style={{ fontSize: 'clamp(15px,1vw,1.2vw)' }}
            onClick={() => {
              const message = encodeURIComponent(t('navbar.whatsapp_message'));
              window.open(`https://wa.me/573155381468?text=${message}`, '_blank');
            }}
          >

            <span>{t('navbar.contact_btn')}</span>
            <BsWhatsapp className="w-4 h-4" />
          </button>

          {/* Botón hamburguesa (visible sólo en mobile) */}
          <button
            onClick={toggleMenu}
            type="button"
            className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100
                          focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
            aria-controls="navbar-sticky"
            aria-expanded={isMenuOpen}
          >
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 17 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1 1h15M1 7h15M1 13h15"
              />
            </svg>
          </button>
        </div>

        {/* Menú Mobile (columna). Aparece sólo si isMenuOpen = true */}
        {isMenuOpen && (
          <div
            className="md:hidden bg-dark "
            style={{
              position: 'absolute',
              top: '100%', // Justo debajo del nav
              right: 0,
              marginTop: '0.5rem',
              width: 'auto',
              padding: '1rem 1.5rem',
              zIndex: "9999",
              opacity: 0.8
            }}
          >
            <ul
              className="flex flex-col space-y-3 font-sans text-white"
              style={{ fontSize: 'clamp(20px,0.8vw,1vw)' }}
            >
              <li className="hover:pb-1 hover:pt-1 hover:border-b-2 hover:border-white transition-all duration-300">
                <button
                  onClick={() => scrollToSection('inicio')}
                  className="text-left w-full"
                >
                  {t('navbar.menu.kit')}
                </button>
              </li>
              <li className="hover:pb-1 hover:pt-1 hover:border-b-2 hover:border-white transition-all duration-300">
                <button
                  onClick={() => scrollToSection('como-funciona')}
                  className="text-left w-full"
                >
                  {t('navbar.menu.how_it_works')}
                </button>
              </li>
              <li className="hover:pb-1 hover:pt-1 hover:border-b-2 hover:border-white transition-all duration-300">
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-left w-full"
                >
                  {t('navbar.menu.advantages')}
                </button>
              </li>
              <li className="hover:pb-1 hover:pt-1 hover:border-b-2 hover:border-white transition-all duration-300">
                <button
                  onClick={() => scrollToSection('experts')}
                  className="text-left w-full"
                >
                  {t('navbar.menu.experts')}
                </button>
              </li>
              <li className="hover:pb-1 hover:pt-1 hover:border-b-2 hover:border-white transition-all duration-300">
                <button
                  onClick={() => scrollToSection('contacto')}
                  className="text-left w-full"
                >
                  {t('navbar.menu.contact')}
                </button>
              </li>
              <li className="hover:pb-1 hover:pt-1 hover:border-b-2 hover:border-white transition-all duration-300">
                <a
                  href="https://bscolombia.com.co/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-left w-full block"
                >
                  {t('navbar.menu.main_site')}
                </a>
              </li>
            </ul>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
